import Image from '@/components/UI/Image';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import { createContext, useContext } from 'react';
import { CardSliderModule, TextModule } from '..';
import css from './index.module.scss';
const CARD_MODULE_TYPES = createContext({
    TEXT_LIST: 'textList' || 1,
    TEXT_IMAGE: 'textImage' || 2,
    TEXT_IMAGE_SLIDE: 'textImageSlide' || 3,
    TEXT_TEXT_LEFT: 'textTextLeft' || 4,
    TEXT_TEXT_RIGHT: 'textTextRight' || 5,
});

const defaultStyle = {
    backColor: '#fff',
    height: 'auto',
    textAlign: 'center',
    sliderConfig: {},
};

const defaultData = {
    type: 'textList', // textList, textImage, textImageSlide, textTextLeft, textTextRight
    textGuide: 'Interior / Exterior Design',
    textTitle: 'Power pretty much anything ',
    textDesc:
        'Keep your home comforts running during a blackout. AC units, kitchen appliances and power tools are all accessible with DELTA Pro. Use a single unit to power up to 4500W¹ of appliances. Need even more power? ',
    items: [
        {
            title: 'Power your home for days',
            desc: 'DELTA Pro’s capacity starts at 3.6kWh. Enough for hours of heavy-duty use. ',
            url: '/img/card-battery-1.png',
        },
        {
            title: 'Power your home for days',
            desc: 'DELTA Pro’s capacity starts at 3.6kWh. Enough for hours of heavy-duty use. ',
            url: '/img/card-battery-2.png',
        },
    ],
    singleImg: '/img/mobile/card-microapp-center.png',
    textTextTitleLeft: 'The world’s fastest wall charge. ',
    textTextTitleRight: 'EV station charging. That’s a world first.',
    textTextDescLeft: 'And of course, you can plug in at home to charge while the grid is online. Get a full charge in as fast as 1.8 hours.',
    textTextDescRight: 'Charge up at thousands of AC level 2 EV stations worldwide to get up to 3400W of input. Enough to charge to full in 1.7 hours.',
};

export default function CardModule({ cssStyle, data }: any) {
    const styles = { ...defaultStyle, ...cssStyle };
    const { EFPic } = createEFPic(styles?.webpUrl);
    const { backColor, height, textAlign, sliderConfig } = styles;
    const dataObj = {
        type: data?.type ?? defaultData.type,
        textGuide: data?.textGuide ?? defaultData.textGuide,
        textTitle: data?.textTitle ?? defaultData.textTitle,
        textDesc: data?.textDesc ?? defaultData.textDesc,
        items: data?.items ?? defaultData.items,
        singleImg: data?.singleImg ?? defaultData.singleImg,
        textTextTitleLeft: data?.textTextTitleLeft ?? defaultData.textTextTitleLeft,
        textTextTitleRight: data?.textTextTitleRight ?? defaultData.textTextTitleRight,
        textTextDescLeft: data?.textTextDescLeft ?? defaultData.textTextDescLeft,
        textTextDescRight: data?.textTextDescRight ?? defaultData.textTextDescRight,
    };
    const cardTypes = useContext(CARD_MODULE_TYPES);
    const { type, textGuide, textTitle, textDesc, items, singleImg, textTextTitleLeft, textTextTitleRight, textTextDescLeft, textTextDescRight } = dataObj;
    const { useEffect, useState, useLang } = useGlobal();
    const { t } = useLang('product');
    const [isIos, setIsIos] = useState(false);
    useEffect(() => {
        const app = navigator.userAgent;
        setIsIos(/Mac OS X/gi.test(app));
    }, []);
    const isWhiteTheme = backColor === '#fff' || backColor === '#ffffff' || backColor === 'white' || backColor === 'transparent';

    const convertData = (data: any) => {
        const result: any = [];
        data.forEach((item: any) => {
            result.push({ img: item.url, desc: item.title });
        });
        return result;
    };

    return (
        <div
            className={isWhiteTheme ? `${css.cardModule} cardModule` : `${css.cardModule} cardModule cardModuleBlackTheme`}
            style={{ background: backColor, height: height }}
        >
            {/* 1. textList: 上文本，下图片列表（列表上部带文字） */}
            {type === cardTypes.TEXT_LIST && (
                <div className="container textListContainer">
                    <TextModule
                        cssStyle={{
                            fontClass: 'font-family-semibold',
                            fontWeight: 500,
                            theme: isWhiteTheme ? 'white' : 'black',
                            textAlign: textAlign,
                            fontSize: '.16rem',
                            lineHeight: '.2rem',
                            color: isWhiteTheme ? '#000' : '#fff',
                            margin: textTitle ? '0 0 .06rem 0' : '0',
                            padding: '0 .2rem',
                        }}
                        data={{ text: textGuide }}
                    />
                    <TextModule
                        cssStyle={{
                            fontClass: 'font-family-extrabold',
                            textAlign: textAlign,
                            fontFamily: 'var(--font-family-ExtraBold)',
                            fontSize: '.24rem',
                            lineHeight: '.34rem',
                            theme: isWhiteTheme ? 'white' : 'black',
                            color: isWhiteTheme ? '#03060b' : '#ffffff',
                            margin: textTitle ? '0 0 .08rem 0' : '0',
                            padding: '0 .2rem',
                        }}
                        data={{ text: textTitle }}
                    />
                    <TextModule
                        cssStyle={{
                            fontClass: 'font-family-medium',
                            textAlign: textAlign,
                            fontSize: '.14rem',
                            lineHeight: '.22rem',
                            theme: isWhiteTheme ? 'white' : 'black',
                            color: isWhiteTheme ? 'rgb(34,34,34)' : 'rgb(145,145,145)',
                            margin: textDesc ? '0 0 .48rem 0' : '0',
                            padding: '0 .2rem',
                            wordSpacing: '0.5px',
                        }}
                        data={{ text: textDesc }}
                    />
                    <div className="listBox">
                        {items.map((item: any, k: number) => (
                            <li className="list" key={k} style={{ background: isWhiteTheme ? '#fff' : '#000' }}>
                                <div className="signFullImgsBox">
                                    {Array.isArray(item.url) ? (
                                        <EFPic name={item.url} alt={t(item.alt)} />
                                    ) : (
                                        <Image src={item.url} layout="fill" alt={t(item.alt)} />
                                    )}
                                </div>
                                <div className="floatText">
                                    <p
                                        className={`listText listTextTitle font-family-extrabold ${isIos ? 'iphone-text' : ''}`}
                                        style={{
                                            color: isWhiteTheme ? '' : '#fff',
                                        }}
                                    >
                                        {item.title}
                                    </p>
                                    <p
                                        className={`listText listTextDesc font-family-medium ${isIos ? 'iphone-text' : ''}`}
                                        style={{
                                            color: isWhiteTheme ? '' : '#919191',
                                        }}
                                        dangerouslySetInnerHTML={{ __html: item.desc }}
                                    ></p>
                                </div>
                            </li>
                        ))}
                    </div>
                </div>
            )}
            {/* 2. textImage: 上文本，下大图排列 */}
            {type === cardTypes.TEXT_IMAGE && (
                <div className="textImageContainer">
                    <div className="container">
                        <TextModule
                            cssStyle={{
                                fontClass: 'font-family-semibold',
                                fontFamily: 'var(--font-family-SemiBold)',
                                fontWeight: 500,
                                theme: isWhiteTheme ? 'white' : 'black',
                                textAlign: textAlign,
                                fontSize: '.16rem',
                                lineHeight: '.2rem',
                                color: isWhiteTheme ? '#000' : '#fff',
                                margin: textTitle ? '0 0 .06rem 0' : '0',
                                padding: '0 .45rem',
                            }}
                            data={{ text: textGuide }}
                        />
                        <TextModule
                            cssStyle={{
                                fontClass: 'font-family-extrabold',
                                fontFamily: 'var(--font-family-ExtraBold)',
                                textAlign: textAlign,
                                fontSize: '.24rem',
                                lineHeight: '.34rem',
                                theme: isWhiteTheme ? 'white' : 'black',
                                color: isWhiteTheme ? '#03060b' : '#ffffff',
                                margin: textTitle ? '0 0 .08rem 0' : '0',
                                padding: '0 .45rem',
                            }}
                            data={{ text: textTitle }}
                        />
                        <TextModule
                            cssStyle={{
                                fontClass: 'font-family-medium',
                                textAlign: textAlign,
                                fontSize: '.14rem',
                                lineHeight: '.22rem',
                                theme: isWhiteTheme ? 'white' : 'black',
                                color: isWhiteTheme ? 'rgb(34,34,34)' : 'rgb(145,145,145)',
                                margin: textDesc ? '0 0 .4rem 0' : '0',
                                padding: '0 .45rem',
                            }}
                            data={{ text: textDesc }}
                        />
                    </div>
                    <div className="listBox">
                        {items.map((item: any, k: number) => (
                            <li className="list" key={k}>
                                {Array.isArray(item.url) ? (
                                    <EFPic name={item.url} className="fullImgs" alt={t(item.alt)} />
                                ) : (
                                    <Image src={item.url} layout="fill" className="fullImgs" alt={t(item.alt)} />
                                )}
                                <span className={k === 0 ? 'label labelRight font-family-extrabold' : 'label font-family-extrabold'}>{item.guide}</span>
                            </li>
                        ))}
                    </div>
                </div>
            )}
            {/* 3. textImageSlide: 上文本，下可滑动图片 */}
            {type === cardTypes.TEXT_IMAGE_SLIDE && (
                <div className={`${css.textImageSlide} textImageSlide`}>
                    <div className="container">
                        <TextModule
                            cssStyle={{
                                fontClass: 'font-family-semibold',
                                fontFamily: 'var(--font-family-SemiBold)',
                                fontWeight: 500,
                                theme: isWhiteTheme ? 'white' : 'black',
                                textAlign: textAlign,
                                fontSize: '.16rem',
                                lineHeight: '.2rem',
                                color: isWhiteTheme ? '#000' : '#ededed',
                                margin: textTitle ? '0 0 .06rem 0' : '0',
                                padding: '0 .45rem',
                            }}
                            data={{ text: textGuide }}
                        />
                        <TextModule
                            cssStyle={{
                                fontClass: 'font-family-extrabold',
                                fontFamily: 'var(--font-family-ExtraBold)',
                                textAlign: textAlign,
                                fontSize: '.24rem',
                                lineHeight: '.34rem',
                                theme: isWhiteTheme ? 'white' : 'black',
                                color: isWhiteTheme ? '#03060b' : '#ffffff',
                                margin: textTitle ? '0 0 .08rem 0' : '0',
                                padding: '0 .45rem',
                            }}
                            data={{ text: textTitle }}
                        />
                        <TextModule
                            cssStyle={{
                                fontSize: '.14rem',
                                textAlign: textAlign,
                                theme: isWhiteTheme ? 'white' : 'black',
                                fontClass: 'font-family-medium',
                                color: isWhiteTheme ? 'rgb(34,34,34)' : '#999999',
                                margin: textDesc ? '0 0 .4rem 0' : '0',
                                padding: '0 .45rem',
                            }}
                            data={{ text: textDesc }}
                        />
                    </div>
                    <CardSliderModule
                        data={convertData(items)}
                        cssStyle={{
                            ...sliderConfig,
                            ...{ theme: isWhiteTheme ? '#fff' : '#000', borderRadius: '.2rem' },
                            webpUrl: styles?.webpUrl,
                        }}
                    />
                </div>
            )}
            {/* 4. textTextLeft: 左侧纯文字卡片，右侧图片上覆盖文字卡片 */}
            {type === cardTypes.TEXT_TEXT_LEFT && (
                <div className="container textTextLeftContainer" style={{ background: isWhiteTheme ? '#fff' : '#000' }}>
                    <div className="left" style={{ background: isWhiteTheme ? 'rgb(246,246,248)' : 'rgb(24,24,24)' }}>
                        <TextModule
                            data={{ text: textTextTitleLeft }}
                            cssStyle={{
                                fontClass: 'font-family-extrabold',
                                fontFamily: 'var(--font-family-ExtraBold)',
                                backColor: 'transparent',
                                fontSize: '.24rem',
                                lineHeight: '.34rem',
                                color: isWhiteTheme ? '#03060b' : '#ffffff',
                                padding: 0,
                            }}
                        />
                        <TextModule
                            data={{ text: textTextDescLeft }}
                            cssStyle={{
                                fontClass: 'font-family-medium',
                                backColor: 'transparent',
                                fontSize: '.14rem',
                                lineHeight: '.22rem',
                                margin: textTextTitleRight ? '.16rem 0 0 0' : '0',
                                color: isWhiteTheme ? 'rgb(34,34,34)' : 'rgb(145,145,145)',
                                padding: 0,
                            }}
                        />
                    </div>
                    <div className="right" style={{ background: isWhiteTheme ? 'rgb(246,246,248)' : 'rgb(24,24,24)' }}>
                        <div className="backImg">
                            {Array.isArray(singleImg) ? (
                                <EFPic name={singleImg} className="fullImgs" alt={t(textTextTitleLeft)} />
                            ) : (
                                <Image src={singleImg} layout="fill" className="fullImgs" alt={t(textTextTitleLeft)} />
                            )}
                        </div>
                        <div className="imgText">
                            <TextModule
                                data={{ text: textTextTitleRight }}
                                cssStyle={{
                                    fontClass: 'font-family-extrabold',
                                    fontFamily: 'var(--font-family-ExtraBold)',
                                    backColor: 'transparent',
                                    fontSize: '.24rem',
                                    lineHeight: '.34rem',
                                    color: isWhiteTheme ? 'rgb(34,34,34)' : '#ffffff',
                                    padding: 0,
                                }}
                            />
                            <TextModule
                                data={{ text: textTextDescRight }}
                                cssStyle={{
                                    fontClass: 'font-family-medium',
                                    backColor: 'transparent',
                                    fontSize: '.14rem',
                                    lineHeight: '.22rem',
                                    margin: textTextDescRight ? '.16rem 0 0 0' : '0',
                                    color: isWhiteTheme ? 'rgb(34,34,34)' : 'rgb(145,145,145)',
                                    padding: 0,
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
            {/* 5. textTextRight: 右侧纯文字卡片，左侧图片上覆盖文字卡片 */}
            {type === cardTypes.TEXT_TEXT_RIGHT && (
                <div className="container textTextRightContainer" style={{ background: isWhiteTheme ? '#fff' : '#000' }}>
                    <div className="left" style={{ background: isWhiteTheme ? 'rgb(246,246,248)' : 'rgb(24,24,24)' }}>
                        <div className="backImg">
                            {Array.isArray(singleImg) ? (
                                <EFPic name={singleImg} className="fullImgs" alt={t(textTextTitleRight)} />
                            ) : (
                                <Image src={singleImg} layout="fill" className="fullImgs" alt={t(textTextTitleRight)} />
                            )}
                        </div>
                        <div className="imgText">
                            <TextModule
                                data={{ text: textTextTitleRight }}
                                cssStyle={{
                                    fontClass: 'font-family-extrabold',
                                    fontFamily: 'var(--font-family-ExtraBold)',
                                    backColor: 'transparent',
                                    fontSize: '.24rem',
                                    lineHeight: '.34rem',
                                    color: isWhiteTheme ? 'rgb(34,34,34)' : '#ffffff',
                                    padding: 0,
                                }}
                            />
                            <TextModule
                                data={{ text: textTextDescRight }}
                                cssStyle={{
                                    fontClass: 'font-family-medium',
                                    backColor: 'transparent',
                                    fontSize: '.14rem',
                                    lineHeight: '.22rem',
                                    margin: textTextDescRight ? '.16rem 0 0 0' : '0',
                                    color: isWhiteTheme ? 'rgb(34,34,34)' : 'rgb(145,145,145)',
                                    padding: 0,
                                }}
                            />
                        </div>
                    </div>
                    <div className="right" style={{ background: isWhiteTheme ? 'rgb(246,246,248)' : 'rgb(24,24,24)' }}>
                        <TextModule
                            data={{ text: textTextTitleLeft }}
                            cssStyle={{
                                fontClass: 'font-family-extrabold',
                                fontFamily: 'var(--font-family-ExtraBold)',
                                backColor: 'transparent',
                                fontSize: '.24rem',
                                lineHeight: '.34rem',
                                color: isWhiteTheme ? '#03060b' : '#ffffff',
                                padding: 0,
                            }}
                        />
                        <TextModule
                            data={{ text: textTextDescLeft }}
                            cssStyle={{
                                fontClass: 'font-family-medium',
                                backColor: 'transparent',
                                fontSize: '.14rem',
                                lineHeight: '.22rem',
                                margin: textTextTitleRight ? '.16rem 0 0 0' : '0',
                                color: isWhiteTheme ? 'rgb(34,34,34)' : 'rgb(145,145,145)',
                                padding: 0,
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}
